module.exports = __webpack_public_path__ + "img/shopping-cart.ec6620b6.svg";